<template>
  <div class="px-3">
    <div id='visualObjectives' class="visualObjectives" />
  </div>
</template>
<script>
import * as d3 from 'd3'
export default {
  name: 'horizontalChart',
  props: {
    teamData: {
      type: Array,
      default: () => [],
    }
  },

  mounted() {
    const container = document.getElementById('visualObjectives')
    const width = container.offsetWidth 
    const height = 900
    const initialTranslateY = height / 4
    const self = this;
    const svg = d3.select('#visualObjectives')
      .append('svg')
      .attr('id', 'visualObjectivesSVG')
      .attr('width', width)
      .attr('height', height)
      .call(d3.zoom().scaleExtent([1, 1]).on('zoom', zoomed))
      .append('g')
      .on("dblclick.zoom", null) 
    let i = 0
    const duration = 700
    const treemap = d3.tree().size([height, width]).nodeSize([150, 0])

    // Assigns parent, children, height, depth
    const root = d3.hierarchy(this.teamData[0])
    root.x0 = initialTranslateY
    root.y0 = 30
    function zoomed(event) {
        const { x, y, k } = event.transform;
        svg.attr('transform', `translate(${x},${y}) scale(${k})`);
      }
    // Collapse after the second level
    root.children.forEach(collapse)

    update(root)

    // Collapse the node and all it's children
    function collapse(d) {
      if (d.children) {
        d._children = d.children
        d._children.forEach(collapse)
        d.children = null
      }
    }
    function diagonal(s, d) {
      const sy = s.y
      const dy = d.y + 210
      return `M ${sy} ${s.x} C ${(s.y + dy) / 2} ${s.x}, ${(s.y + dy) / 2} ${d.x},${dy} ${d.x}`
    }

    function update(source) {
      const treeData = treemap(root)

      // Compute the new tree layout.
      const nodes = treeData.descendants()
      const links = treeData.descendants().slice(1)

      // Normalize for fixed-depth.
      nodes.forEach((d) => {
          d.y = d.depth * 350;
          d.x += root.x0; 
          d.y += root.y0;
        });

      // ****************** Nodes section ***************************

      // Update the nodes...
      const node = svg.selectAll('g.node').data(nodes, (d) => d.id || (d.id = ++i))

      // Enter any new modes at the parent's previous position.
      const nodeEnter = node.enter().append('g')
        .attr('class', 'node')
        .attr('transform', () => `translate(${source.y0},${source.x0})`)

      // Node Elements
      const group = nodeEnter.append('g')
      // Division
      group.append('rect')
        .attr('class', 'rect')
        .attr('width', 246)
        .attr('height', 74)
        .attr('rx', 5)
        .attr('ry', 5)
        .attr('y', -32)
        .style('fill', function (d) {
          return d.data.nivel === "1" ? '#E1F5FE' : '#fff'
        })
      // Name Collaborator
      group.append('text')
        .attr('class', 'node-name-collaborator')
        .attr('y', -8)
        .attr('x', 60)
        .text((d) => {
          const name = d.data.nombre
          let names = d.data.nickname ? d.data.nickname : name.trim()
          return (names.length > 15) ? names.substring(0, 15) + '...' : names
        })

      // Name Position
      group.append('text')
        .attr('class', 'node-name-position')
        .attr('y', 7)
        .attr('x', 60)
        .text((d) => (d.data.cargo.length > 18) ? d.data.cargo.substring(0, 18) + '...' : d.data.cargo)
      // Email
      group.append('text')
        .attr('class', 'node-name-position')
        .attr('y', 22)
        .attr('x', 60)
        .text((d) => (d.data.mail.length > 18) ? d.data.mail.substring(0, 18) + '...' : d.data.mail)

      // Avatar
      group.append('circle')
        .attr('cx', 32)
        .attr('r', 20)
        .style('fill', '#2196F3')

      group.append('text')
        .attr('class', 'avatar-text')
        .attr('x', 32)
        .attr('y', 0)
        .attr('text-anchor', 'middle')
        .attr('dy', '.35em')
        .style('fill', 'white')
        .text((d) => {
          const n = d.data.nombre
          return n ? n.charAt(0).toUpperCase() : ''
        })

      // Add Circle for the nodes
      nodeEnter.append('circle')
        .attr('display', (d) => (d.data.children) ? '' : 'none')
        .attr('class', 'node-circle ')
        .attr('cx', 252)
        .attr('cy', 5)
        .attr('r', 15)
        .style('fill', function (d) {
          return d._children ? '#29B6F6' : '#fff'
        })
        .on('click', (event, d) => {
          click(d)
        });

      // Add Arrow Icon
      nodeEnter.append('foreignObject')
        .attr('display', (d) => (d.data.children) ? '' : 'none')
        .attr('class', 'arrow-icon')
        .attr('class', 'pointer-cursor')
        .attr('x', 240)
        .attr('y', -6)
        .attr('width', 24)
        .attr('height', 24)
        .append('xhtml:body')
        .html(function (d) {
          return d._children ?
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="#2196F3" d="M43 17.1L39.9 14L24 29.9L8.1 14L5 17.1L24 36z" transform="rotate(-90, 24, 24)"/></svg>':
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="#2196F3" d="M43 17.1L39.9 14L24 29.9L8.1 14L5 17.1L24 36z" transform="rotate(90, 24, 24)"/></svg>'
        })
        .on('click', (event, d) => {
          click(d)
        });

      // Click Area
      nodeEnter.append('rect')
        .attr('class', 'rect-link')
        .attr('width', 230)
        .attr('height', 74)
        .attr('rx', 5)
        .attr('ry', 5)
        .attr('y', -32)
        .each(function(d) {
        const rect = d3.select(this);
        
        if (d.data.nivel !== "0") {
          rect.on('click', (event, d) => {
            self.goToemployeeView(d.data.id);
          })
          .classed('pointer-cursor', true); 
        }
      });

      group.append('rect')
        .attr('class', 'children-rect')
        .attr('width', 26)
        .attr('height', 50)
        .attr('x', 200)
        .attr('y', -18)
        .style('fill', function (d) {
          return d.data.nivel === "1" ? '#E1F5FE' : '#FFF';
        })
      // Agregar el texto del nivel
      group.append('text')
        .attr('class', 'nivel-text')
        .attr('x', 210)
        .attr('y', 25)
        .style('fill', 'black')
        .text((d) => (d.data.children ? d.data.children.length : '0'));

      const foreignObject = group.append('foreignObject')
        .attr('width', 25)
        .attr('height', 40)
        .attr('x', 203)
        .attr('y', -10);
      foreignObject.append('xhtml:div')
        .html(`      <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.6666 10.6667C22.6666 11.9852 22.2756 13.2741 21.543 14.3705C20.8105 15.4668 19.7693 16.3213 18.5511 16.8259C17.333 17.3304 15.9925 17.4625 14.6993 17.2052C13.4061 16.948 12.2182 16.3131 11.2859 15.3807C10.3535 14.4484 9.71858 13.2605 9.46135 11.9673C9.20412 10.6741 9.33614 9.33362 9.84072 8.11544C10.3453 6.89727 11.1998 5.85608 12.2961 5.12354C13.3924 4.39099 14.6814 4 15.9999 4C17.768 4 19.4637 4.70238 20.714 5.95262C21.9642 7.20286 22.6666 8.89856 22.6666 10.6667ZM17.3333 17.3333H14.6666C12.1912 17.3333 9.81726 18.3167 8.06692 20.067C6.31658 21.8173 5.33325 24.1913 5.33325 26.6667V26.6667C5.33325 27.0203 5.47373 27.3594 5.72378 27.6095C5.97382 27.8595 6.31296 28 6.66659 28H25.3333C25.6869 28 26.026 27.8595 26.2761 27.6095C26.5261 27.3594 26.6666 27.0203 26.6666 26.6667C26.6666 24.1913 25.6833 21.8173 23.9329 20.067C22.1826 18.3167 19.8086 17.3333 17.3333 17.3333V17.3333Z"
            stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M22.6667 14.0027C23.3313 14.1457 25.8704 14.0723 26.4964 13.792C27.1224 13.5117 27.6575 13.0369 28.0339 12.4279C28.4103 11.8188 28.6113 11.1027 28.6113 10.3702C28.6113 9.38792 28.2503 8.44587 27.6078 7.75129C26.9654 7.05671 26.094 6.6665 25.1854 6.6665C24.5079 6.6665 23.8455 6.88372 23.2821 7.29069M24.5003 14.0739H25.8706C27.1426 14.0739 28.3625 14.6202 29.262 15.5926C30.1614 16.565 30.6667 17.8839 30.6667 19.2591C30.6667 19.4556 30.5946 19.644 30.4661 19.7829C30.3376 19.9218 30.1633 19.9998 29.9816 19.9998H24.5003"
            stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M9.33325 14.0027C8.66871 14.1457 6.12956 14.0723 5.50357 13.792C4.87758 13.5117 4.34254 13.0369 3.96611 12.4279C3.58967 11.8188 3.38875 11.1027 3.38875 10.3702C3.38875 9.38792 3.74968 8.44587 4.39215 7.75129C5.03462 7.05671 5.90599 6.6665 6.81458 6.6665C7.49214 6.6665 8.15449 6.88372 8.71787 7.29069M7.49974 14.0739H6.12941C4.85739 14.0739 3.63747 14.6202 2.73802 15.5926C1.83856 16.565 1.33325 17.8839 1.33325 19.2591C1.33325 19.4556 1.40544 19.644 1.53393 19.7829C1.66243 19.9218 1.8367 19.9998 2.01842 19.9998H7.49974"
            stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>`);

      // UPDATE
      const nodeUpdate = nodeEnter.merge(node)

      // Transition to the proper position for the node
      nodeUpdate.transition()
        .duration(duration)
        .attr('transform', (d) => 'translate(' + (d.y - 25) + ',' + (d.x - 5) + ')')

      // Update the node attributes and style
      nodeUpdate.select('foreignObject.arrow-icon')
        .html(function (d) {
          return d._children ?
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="#2196F3" d="M43 17.1L39.9 14L24 29.9L8.1 14L5 17.1L24 36z" transform="rotate(-90, 24, 24)"/></svg>':
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="#2196F3" d="M43 17.1L39.9 14L24 29.9L8.1 14L5 17.1L24 36z" transform="rotate(90, 24, 24)"/></svg>'
        })
        .on('click', (event, d) => {
          click(d)
        });

      // Update the node attributes and style
      nodeUpdate.select('circle.node-circle')
        .attr('r', 15)
        .style('fill', function (d) {
          return d._children ? '#c9e4ff' : '#fff'
        })
        .style('stroke-width', function () {
          return '2px'
        })
        .attr('cursor', 'pointer')

      // Remove any exiting nodes
        node.exit().transition()
        .duration(duration)
        .attr('transform', function () {
          return 'translate(' + source.y + ',' + source.x + ')'
        })
        .remove()

      // ****************** links section ***************************

      // Update the links...
      const link = svg.selectAll('path.link')
        .data(links, function (d) { return d.id })

      // Enter any new links at the parent's previous position.
      const linkEnter = link.enter().insert('path', 'g')
        .attr('class', 'link')
        .attr('d', function () {
          const o = { x: source.x0, y: source.y0 }
          return diagonal(o, o)
        })
      // UPDATE
      const linkUpdate = linkEnter.merge(link)

      // Transition back to the parent element position
      linkUpdate.transition()
        .duration(duration)
        .attr('d', function (d) { return diagonal(d, d.parent) })

      // Remove any exiting links
      link.exit().transition()
        .duration(duration)
        .attr('d', function () {
          var o = { x: source.x, y: source.y }
          return diagonal(o, o)
        })
        .remove()

      // Store the old positions for transition.
      nodes.forEach(function (d) {
        d.x0 = d.x
        d.y0 = d.y
      })

      // Toggle children on click.
      function click(d) {
        if (d.children) {
          d._children = d.children
          d.children = null
        } else {
          d.children = d._children
          d._children = null
        }
        update(d)
      }
    }
  },
  methods: {
    goToemployeeView(id) {
      this.$router.push({ name: "infoEmployee", params: { id: id, routerGoBack:'myteam'} });
    },
  },
}
</script>

<style>

.pointer-cursor {
  cursor: pointer;
}
.link {
  fill: none;
  stroke: #ccc;
  stroke-width: 2px;

}

.node-circle {
  stroke: #29B6F6 !important;
  stroke-width: 2px;
  cursor: pointer;
}

.circle-none {
  display: none;
}

.rect {
  fill: #fff;
  stroke: #29B6F6;
  stroke-width: 3;
  stroke-opacity: 0.5;
}

.rect-link {
  fill: #fff;
  fill-opacity: 0;
  /* cursor: pointer; */
}

.children-rect {
  fill: #fff;
  stroke: #000;
  stroke-width: 1;
  stroke-opacity: 0.5;
}

.rect-link--none {
  display: none;
}

.node-name-collaborator {
  font-size: 13px;
  stroke: none;
  font-weight: bold;
}

.node-name-position {
  font-size: 12px;
  fill: #999;
  stroke: none;
}

.visualObjectives #visualObjectivesSVG {
  height: 100% !important;
}

.avatar-text {
  font-size: 20px;
  font-weight: bold;
}

.bg-neutro-600 {
  background-color: #707070;
}
</style>